import { render, staticRenderFns } from "./answer-identity.vue?vue&type=template&id=7f6d1d86&scoped=true&"
import script from "./answer-identity.vue?vue&type=script&lang=js&"
export * from "./answer-identity.vue?vue&type=script&lang=js&"
import style0 from "./answer-identity.vue?vue&type=style&index=0&id=7f6d1d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d1d86",
  null
  
)

export default component.exports